import React from 'react';
import { ILegalTransactionRelationship } from '../../../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { DocumentOverview } from '../../../../../Document/DocumentOverview';
import { IDocument } from '../../../../../../Interfaces/IDocument';
import { Box, Button, Typography } from '@mui/material';

interface IProps {
  relationship: ILegalTransactionRelationship;
  setRelationsship: Function;
  handleBack: Function;
  handleNext: Function;
}

export const LandRegisterQueryDocuments: React.FC<IProps> = ({
  relationship,
  setRelationsship,
  handleBack,
  handleNext,
}) => {
  const documentArray = relationship.DocumentArray;
  const setDocumentArray = (newDocArray: IDocument[]) => {
    setRelationsship({
      ...relationship,
      DocumentArray: newDocArray,
    });
  };

  return (
    <>
      <Box sx={{ mt: 5 }} />

      <Typography variant='h4'>Dokumente</Typography>
      <Typography sx={{ mb: 3 }}>
        Sie haben hier die Möglichkeit, im Rahmen Ihrer Anfrage eines
        Grundbuchauszuges optional relevante Dokumente hochzuladen. Dies können
        Unterlagen sein, die zur Bearbeitung Ihrer Anfrage beitragen oder für
        die Zuordnung und Prüfung der Daten hilfreich sind (z. B. Vollmachten,
        Ausweiskopien, Lagepläne etc.).
        <br />
        Bitte beachten Sie, dass der Upload freiwillig ist – Ihre Anfrage kann
        selbstverständlich auch ohne zusätzliche Dokumente gestellt werden.
      </Typography>

      <DocumentOverview
        allowRemove
        allowUpload
        documentArray={documentArray}
        setDocumentArray={setDocumentArray}
        title=''
      />

      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button variant='outlined' onClick={() => handleBack()} sx={{ mr: 1 }}>
          Zurück
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />
        <Button type='submit' variant='contained' onClick={() => handleNext()}>
          Weiter
        </Button>
      </Box>
    </>
  );
};
